import { FormGroup } from '@angular/forms';

export class BaseStepComponent {
  public isAnyHaveError(form: FormGroup, controls: string[], errorCodes: string[]): boolean {
    for (const control of controls) {
      if (this.hasError(form, control, errorCodes)) {
        return true;
      }
    }

    return false;
  }

  public hasError(form: FormGroup, control: string, errorCodes: string[]): boolean {
    for (const errorCode of errorCodes) {
      if (form.get(control)?.hasError(errorCode)) {
        return true;
      }
    }

    return false;
  }

  public isTouchedAndHasError(form: FormGroup, control: string, errorCodes: string[]): boolean {
    if (!form.get(control)?.touched) {
      return false;
    }

    return this.hasError(form, control, errorCodes);
  }
}
